<div class="background-blur"></div>
<p class="text-center mb-2" style="color: #fff; font-weight: 600; font-size: 18px">
  {{data.message}}
</p>
<p *ngIf="data.additionalText" class="text-center m-0" style="color: #fff; font-size: 14px">{{data.additionalText}}</p>
